export default "__VITE_ASSET__DSYPKXKO__"